import { render } from "./TabPointHistory.vue?vue&type=template&id=2e2e1a7d"
import script from "./TabPointHistory.vue?vue&type=script&lang=js"
export * from "./TabPointHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__